import React, { useState,useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Helmet } from "react-helmet";
import { useParams, Link } from "react-router-dom";
import './classes/ViewScoutingRequestsScout.css';
import { Pagination, Box } from "@mui/material";
import Loading from './Loading';
import { configData } from "../config";

    


// === Sport Map
const sportMap = {
  1: "Football (American)",
  2: "Baseball",
  3: "Basketball",
  4: "Soccer",
  6: "Hockey",
  8: "Cricket",
  46: "Rugby",
};
 
 const sportOrder = ["All", ...Object.values(sportMap)];

// === Main Component
const ViewScoutingRequestsScout = () => {
  const { id } = useParams();
  const selectedSport = id ? sportMap[id] : "All";
const [isLoading, setIsLoading] = useState(true);
  const[scoutingData,setScoutingData] = useState({});
      const [showConfirmDialog, setShowConfirmDialog] = useState(false);
        const [submissionid, setSubmissionId] = useState('');
        const[error,setError] = useState('');
             const[message,setMessage] = useState([]);
                const[success,setSuccess] = useState('');
                const loggedin_uid = localStorage.getItem('uid');
     const handleApprovalClick = (sid) => {
          setShowConfirmDialog(true);
          setSubmissionId(sid);
        };
        const popuprows = [
  { id: 1, report: 0, scouts: [] },
  {
    id: 2,
    report: 2,
    scouts: [
      { id: 273, name: "Test1" },
      { id: 569, name: "Test2" },
    ],
  },
  { id: 3, report: 1, scouts: [{ id: 101, name: "John Doe" }] },
];
 const [selectedScouts, setSelectedScouts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const openPopup = (scouts) => {
    setSelectedScouts(scouts);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedScouts([]);
  };

        const columns = [
  { field: "sport", headerName: "Player's Sport", flex: 1,sortable: false },
  { field: "player", headerName: "Player", flex: 1,sortable: false },
  { field: "age", headerName: "Player's Age", flex: 1 ,sortable: false},
  { field: "team", headerName: "Player's Team", flex: 1 ,sortable: false},
  { field: "position", headerName: "Player's Position", flex: 1 ,sortable: false},
  { field: "location", headerName: "Player's Location", flex: 1,sortable: false },
  { field: "date", headerName: "Date Requested", flex: 1,sortable: false },
  { field: "requester", headerName: "Requester", flex: 1,sortable: false },
  { field: "relation", headerName: "Requester's Relationship to Player", flex: 1,sortable: false },
  {
      field: "accepted_count",
      headerName: "# of Scouts Reporting",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const count = params.value;
        return count > 0 ? (
          <a
            href="#"
            style={{ cursor: "pointer", color: "#2C99D2" }}
            onClick={() => openPopup(params.row.scouts)}
          >
            {count}
          </a>
        ) : (
          count
        );
      },
    },
    {
    field: 'action',
    headerName: 'Action',
    headerClassName: 'super-app-theme--header',
        sortable: false,
      flex:1, 
      renderCell: (params) => (
        <><img  style={{cursor: "pointer" }} onClick={() => handleApprovalClick(params.row.sid)} className="approval_image"  src="/basic/web/images/approve.gif" alt="Approve" border="0" align="top" /></>
          )
    
  },
];

const flattenGroupedData = (grouped) => {
  const flat = [];
  for (const [sport, rows] of grouped) {
    for (const row of rows) {
      flat.push({ sport, row });
    }
  }
  return flat;
};

const paginateFlatRows = (flatRows, pageSize = 50) => {
  const pages = [];
  let currentPage = [];
  let currentSport = null;
  let currentRows = [];

  for (let i = 0; i < flatRows.length; i++) {
    const { sport, row } = flatRows[i];

    if (currentSport !== sport) {
      if (currentRows.length > 0) {
        currentPage.push({ sport: currentSport, rows: currentRows });
        currentRows = [];
      }
      currentSport = sport;
    }

    currentRows.push(row);

    const rowCount = currentPage.reduce((sum, s) => sum + s.rows.length, 0) + currentRows.length;
    if (rowCount >= pageSize || i === flatRows.length - 1) {
      currentPage.push({ sport: currentSport, rows: currentRows });
      pages.push(currentPage);
      currentPage = [];
      currentRows = [];
      currentSport = null;
    }
  }

  return pages;
};

// === Grid Renderer
const CategoryGrid = ({ title, rows }) => (
  <div className="category-section">
    <div className="category-title">{title}</div>
    <div className="grid-wrapper">
      <DataGrid
        rows={rows}
        columns={columns}
       autoHeight
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableSelectionOnClick
        getRowId={(row) => row.id}
        sx={{ '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' } }}
      />
    </div>
  </div>
);
   const app_url = configData.APP_URL;
 useEffect(() => {
    Promise.all([
    retrieveScoutingrequestlist(),
   setScoutingData(popuprows),
   checkpermissionforpageaccess()
     ]).then(() => {
     
      setIsLoading(false);
     
     });   
    
   },[]);
     
  async function retrieveScoutingrequestlist() {
    
   
    const response = await fetch(
      app_url+'smwwscout/scoutingrequestlistscout',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    // if(responsedata.data.msg === "Success") {
    //    console.log(scoutingData)
    //   setScoutingData(responsedata.data.result);
    // }
    if (responsedata.data.msg === "Success") {
  console.log("Fetched scouting data:", responsedata.data.result);
setScoutingData(responsedata.data.result);
 
  
}

 
  }
  async function checkpermissionforpageaccess() {
       
          
               const response = await fetch(
                    app_url+'smwwscout/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
   
          
       }
 const handleClick = async (value) => {
   try {
         setIsLoading(true);
      const response = await fetch(
      app_url+'smwwscout/scoutingrequestlistscout?sport='+value,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    // if(responsedata.data.msg === "Success") {
    //    console.log(scoutingData)
    //   setScoutingData(responsedata.data.result);
    // }
    if (responsedata.data.msg === "Success") {
  setScoutingData(responsedata.data.result);
  setPage(1);
}

       }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
   const filteredData =
    selectedSport === "All"
      ? scoutingData
      : scoutingData.filter((d) => d.sport === selectedSport);

  const grouped = new Map();
   if (Array.isArray(filteredData)) {
  for (const row of filteredData) {
    if (!grouped.has(row.sport)) grouped.set(row.sport, []);
    grouped.get(row.sport).push(row);
  }
}

//  const pages = paginateFlatRows(flattenGroupedData(grouped), 50);
// get array of grouped entries (sport string, rows array)
const sortedGroupedEntries = Array.from(grouped.entries())
  .sort(([sportA], [sportB]) => {
    return sportOrder.indexOf(sportA) - sportOrder.indexOf(sportB);
  });

// then flatten + paginate
const pages = paginateFlatRows(flattenGroupedData(sortedGroupedEntries), 50);
  const [page, setPage] = useState(1);

 
      const handleConfirm = async () => {
      setShowConfirmDialog(false);
      try {
        const response = await fetch(
                app_url+'smwwscout/acceptscoutreport',
                {
                    method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                sid: submissionid,
                loggedin_id: localStorage.getItem('drupal_uid')
                
              }),
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
              
              setSuccess(responsedata.data.result);
              setError('');
              window.scrollTo(0, 0);
            }
             if(responsedata.data.msg == "Error") {
             setSuccess('');
              setError(responsedata.data.result);

            }
      } catch (error) {
        console.error('API call failed:', error);
      }
    };
     const handleCancel = () => {
      setShowConfirmDialog(false);
    };

  return (
    <>
       {isLoading ? (
            <Loading />
          ) : (
    <div id="main" className="scout-domain-scouting-request-main">
      <Helmet><title>Scouting Requests</title></Helmet>
      <div className="left"></div>
      <div className="scout-domain-scouting-request-center">
{message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
			  
        <><div className="scout-domain-scouting-request-container">
          {error && (
                    <div className="set-message-error">
                    {error}
                    </div>
          
                     )}  
          
        
       {success && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span  dangerouslySetInnerHTML={{ __html: success}}></span>
          </div>
          
       
        )}
                              {showConfirmDialog && (
       <div className="dialog-overlay">
          <div className="dialog-content">
            <h2>Confirmation</h2>
           <p> By agreeing to provide this scouting report, you must send it within 5<br/> to 7 business days to the requester's email and accept to incur any<br/> expenses at your own risk.</p>
<p>You will have access to all of the submitted details if you agree.</p>
<p>Click OK to continue and confirm your decision.</p>
            <div className="dialog-actions">
              <button onClick={handleConfirm}>Ok</button>
              <button onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        </div>
    )}
        {modalOpen && (
        <div  id="editModal" className="modal view-event-modal edit-modal-all">
          <div className="modal-content scout-modal">
            <p style={{ float: "right", margin: "5px" }}>
              <span
                style={{ fontSize: "18px", cursor: "pointer" }}
                onClick={closeModal}
              >
                ×
              </span>
            </p>
            <hr style={{ clear: "both", border: "1px solid #003c7d" }} />
            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                margin: "20px 0",
                color: "#003c7d",
              }}
            >
              Scout(s) Reporting
            </div>
            <ul>
              {selectedScouts.map((scout) => (
                <li key={scout.id}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={scout.link}
                  >
                    {scout.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
          <div className="view-header">
            <p>
              <a href onClick={()=>handleClick("All")} style={{cursor:'pointer'}}>ALL</a>
              {Object.entries(sportMap).map(([key, sport]) => (
                <React.Fragment key={key}>
                  &nbsp;|&nbsp;
                 <a href style={{cursor:'pointer'}} onClick={()=>handleClick(key)}>{sport}</a>
                </React.Fragment>
              ))}
            </p>
          </div>

          <div className="scouting-tables">
            {pages[page - 1]?.map(({ sport, rows }, idx) => (
              <CategoryGrid
                key={`${sport}-${rows[0]?.id}-${idx}`}
                title={`Player's Sport: ${sport}`}
                rows={rows}
              />
            ))}
          </div>

          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={pages.length}
              page={page}
              onChange={(_, val) => {setPage(val);window.scrollTo(0,0);}}
              color="primary"
            />
          </Box>
        </div></>
              )}
      </div>
    
    </div>
    
  )}
  </>
);
};

export default ViewScoutingRequestsScout;